var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, unstable_usePrompt as usePrompt } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { ActionModal } from 'components/Shared/ActionModal/ActionModal';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import { StyledButton } from 'components/Shared/StyledButton/StyledButton';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { CpaProductMetadata } from '@millerknoll/pub-api-schema';
import { DEVIATION_MAX_LENGTH } from 'utils/constants';
import { CpaProductType, saveProduct, checkUserLockPreventsEdit, deleteLock, updateLockApi, } from 'utils/cpa-utils';
import { getUserOrSignIn } from 'services/auth/AuthService';
import { BannerIconType, BannerMessageType, useBanner } from 'components/Shared/BannerContext/BannerContext';
import { CpaProductHeaderBanner } from './CpaProductHeaderBanner/CpaProductHeaderBanner';
import { useCpaProduct } from '../CpaProduct/CpaProductContextProvider';
import { CpaUnsavedEditCheckLabel } from './CpaUnsavedEditCheckLabel/CpaUnsavedEditCheckLabel';
import { CpaProductHeaderPricing } from './CpaProductHeaderPricing/CpaProductHeaderPricing';
import { CpaProductHeaderAdditionalInfoWorkOrder } from './CpaProductHeaderProductInfo/CpaProductHeaderProductInfoWorkOrder';
import { CpaProductHeaderAdditionalInfoSpecials } from './CpaProductHeaderProductInfo/CpaProductHeaderProductInfoSpecials';
import { CpaProductMode } from '../CpaProduct/CpaProductReducer';
import styles from './CpaProductHeader.module.scss';
export function CpaProductHeader() {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var cpaProductContext = useCpaProduct();
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var navigate = useNavigate();
    var _f = useState(false), saveLoading = _f[0], setSaveLoading = _f[1];
    var _g = useState(false), isLocked = _g[0], setIsLocked = _g[1];
    var _h = useState(false), isExtendTimeEnabled = _h[0], setIsExtendTimeEnabled = _h[1];
    var _j = useState(false), extendTimeModelOpen = _j[0], setExtendTimeModelOpen = _j[1];
    var _k = useState(false), isLockExtended = _k[0], setIsLockExtended = _k[1];
    var timeoutRef = useRef(null);
    var getLockedRecordMessage = function (minutes) {
        return "You've made edits to this record and its currently locked for others. Please save your changes within the next ".concat(minutes, " minutes or they will be lost.");
    };
    var _l = useBanner(), bannerMessage = _l.bannerMessage, setBannerMessage = _l.setBannerMessage, bannerType = _l.bannerType, setBannerType = _l.setBannerType, bannerIcon = _l.bannerIcon, setBannerIcon = _l.setBannerIcon, showBanner = _l.showBanner, setShowBanner = _l.setShowBanner, isRefreshEnabled = _l.isRefreshEnabled, setIsRefreshEnabled = _l.setIsRefreshEnabled;
    /**
     * the below usePrompt and useEffect are used to prevent navigation and
     * page close/refresh while a save is in progress
     */
    usePrompt({ when: saveLoading, message: 'Save in progress. Do you still want to navigate?' });
    usePrompt({ when: isLocked, message: 'Record is locked. Do you still want to navigate?' });
    var checkLockUpdateIncrement = useCallback(function (lock) {
        var lockExtensionExpTime = Number(lock.ttl) - Number(process.env.REACT_APP_DEFAULT_CPA_LOCK_TIMEOUT_SECONDS);
        var currentEpochSeconds = Math.floor(Date.now() / 1000);
        var timeoutSeconds = lockExtensionExpTime - currentEpochSeconds;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        if (timeoutSeconds > 0) {
            timeoutRef.current = setTimeout(function () {
                setIsExtendTimeEnabled(true);
                setBannerMessage('You have less than 5 minutes to save changes. ');
                setBannerType(BannerMessageType.Error);
                setBannerIcon(BannerIconType.Error);
                setExtendTimeModelOpen(true);
            }, timeoutSeconds * 1000);
        }
    }, [setIsExtendTimeEnabled, setBannerMessage, setBannerType, setBannerIcon, setExtendTimeModelOpen]);
    useEffect(function () {
        var lockStringOuter = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_lock"));
        var sessionIdOuter = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_identifier"));
        if (lockStringOuter) {
            var lock = JSON.parse(lockStringOuter);
            if (lock.isLocked) {
                setIsLocked(true);
                setShowBanner(true);
                if (lock.sessionId === sessionIdOuter) {
                    setIsRefreshEnabled(false);
                    setBannerMessage(isLockExtended ? getLockedRecordMessage(5) : getLockedRecordMessage(30));
                    checkLockUpdateIncrement(lock);
                }
                else {
                    setIsRefreshEnabled(true);
                    setBannerMessage("This record is locked because it's currently being edited by somone else. Please reload by clicking here: ");
                    setIsExtendTimeEnabled(false);
                    setExtendTimeModelOpen(false);
                }
                setBannerType(BannerMessageType.Warning);
                setBannerIcon(BannerIconType.Error);
            }
            else if (!lock.isLocked && lock.sessionId !== sessionIdOuter) {
                setShowBanner(true);
                setBannerMessage('Record Unlocked.');
                setBannerType(BannerMessageType.Success);
                setBannerIcon(BannerIconType.Error);
                setIsLockExtended(false);
            }
        }
        var handleLock = function (event) {
            var lockString = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_lock"));
            var sessionId = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_identifier"));
            if (lockString) {
                var lock = JSON.parse(lockString);
                setIsLocked(lock.sessionId === sessionId && lock.isLocked);
                if (lock.isLocked) {
                    setShowBanner(true);
                    if (lock.sessionId === sessionId) {
                        setIsRefreshEnabled(false);
                        setBannerMessage(isLockExtended ? getLockedRecordMessage(5) : getLockedRecordMessage(30));
                        checkLockUpdateIncrement(lock);
                    }
                    else {
                        setIsRefreshEnabled(true);
                        setBannerMessage("This record is locked because it's currently being edited by somone else. Please reload by clicking here: ");
                        setIsExtendTimeEnabled(false);
                        setExtendTimeModelOpen(false);
                    }
                    setBannerType(BannerMessageType.Warning);
                    setBannerIcon(BannerIconType.Error);
                }
                else if (!lock.isLocked && lock.sessionId !== sessionId) {
                    setIsRefreshEnabled(false);
                    setIsExtendTimeEnabled(false);
                    setIsLockExtended(false);
                    setExtendTimeModelOpen(false);
                    setShowBanner(true);
                    setBannerMessage('Record Unlocked.');
                    setBannerType(BannerMessageType.Success);
                    setBannerIcon(BannerIconType.Error);
                }
                // set edit mode per lock state
                cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                    type: 'UPDATE_EDITABLE_BUTTON',
                    payload: checkUserLockPreventsEdit(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn),
                });
            }
            else {
                setIsRefreshEnabled(false);
                setIsLocked(false);
                setIsExtendTimeEnabled(false);
                setIsLockExtended(false);
                setShowBanner(false);
                setExtendTimeModelOpen(false);
            }
        };
        var handleUnlock = function (event) {
            setIsLocked(false);
            setIsLockExtended(false);
            setShowBanner(false);
        };
        var handleUnload = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var lockString, sessionId;
            return __generator(this, function (_a) {
                lockString = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_lock"));
                if (lockString && JSON.parse(lockString).isLocked) {
                    sessionId = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_identifier"));
                    if (JSON.parse(lockString).sessionId === sessionId) {
                        deleteLock(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn);
                    }
                }
                return [2 /*return*/];
            });
        }); };
        var handleBeforeUnload = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var lockString, sessionId;
            return __generator(this, function (_a) {
                lockString = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_lock"));
                if (lockString && JSON.parse(lockString).isLocked) {
                    sessionId = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_identifier"));
                    if (JSON.parse(lockString).sessionId === sessionId) {
                        deleteLock(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn);
                    }
                }
                return [2 /*return*/];
            });
        }); };
        window.addEventListener('lock', handleLock);
        window.addEventListener('unlock', handleUnlock);
        window.addEventListener('unload', handleUnload);
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function () {
            window.removeEventListener('lock', handleLock);
            window.removeEventListener('unlock', handleUnlock);
            window.removeEventListener('unload', handleUnload);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        cpaProductContext,
        isLocked,
        isLockExtended,
        checkLockUpdateIncrement,
        setBannerIcon,
        setBannerMessage,
        setBannerType,
        setShowBanner,
        setIsRefreshEnabled,
    ]);
    var handleSave = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var user, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaveLoading(true);
                    sessionStorage.setItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_inAddEditMode"), CpaProductMode.EDIT);
                    if (!cpaProductContext) return [3 /*break*/, 6];
                    if (!cpaProductContext.data.currentProduct) return [3 /*break*/, 2];
                    return [4 /*yield*/, getUserOrSignIn()];
                case 1:
                    user = _a.sent();
                    cpaProductContext.data.currentProduct.createdBy = user.name;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    setIsExtendTimeEnabled(false);
                    return [4 /*yield*/, saveProduct(cpaProductContext.data)];
                case 3:
                    _a.sent();
                    setIsLockExtended(false);
                    setShowBanner(true);
                    setBannerMessage('Record Saved.');
                    setBannerType(BannerMessageType.Success);
                    setBannerIcon(BannerIconType.Success);
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    setSnackbarAlert({
                        message: error_1.message,
                        type: 'error',
                    });
                    setSaveLoading(false);
                    setTimeout(function () {
                        navigate('/cpa/');
                    }, 0);
                    return [3 /*break*/, 5];
                case 5:
                    cpaProductContext.dispatch({
                        type: 'UPDATE_CURRENT_PRODUCT_ORIGINAL',
                        payload: JSON.parse(JSON.stringify(cpaProductContext.data.currentProduct)),
                    });
                    cpaProductContext.dispatch({
                        type: 'UPDATE_PRICING_TABLE_DATA_ORIGINAL',
                        payload: JSON.parse(JSON.stringify(cpaProductContext.data.pricingTableData)),
                    });
                    _a.label = 6;
                case 6:
                    setSaveLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [
        cpaProductContext,
        setSaveLoading,
        setSnackbarAlert,
        navigate,
        setBannerMessage,
        setBannerIcon,
        setBannerType,
        setShowBanner,
    ]);
    var anyRestrictions = false;
    if (((_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct) === null || _a === void 0 ? void 0 : _a.restrictions) &&
        Object.values((_b = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct) === null || _b === void 0 ? void 0 : _b.restrictions).find(function (el) { return el.isActive === true; })) {
        anyRestrictions = true;
    }
    var saveButtonErrors = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var errorMessages = [];
        var SAVE_BUTTON_ERROR_MESSAGES;
        (function (SAVE_BUTTON_ERROR_MESSAGES) {
            SAVE_BUTTON_ERROR_MESSAGES["LEGACY_EDITS"] = "Edits currently disabled for specials and work orders originating from legacy system.";
            SAVE_BUTTON_ERROR_MESSAGES["DEVIATION_DESC"] = "Deviation description required. (Description tab)";
            SAVE_BUTTON_ERROR_MESSAGES["DEVIATION_DESC_MAX_LENGTH"] = "Deviation description exceeds max length. (Description tab)";
            SAVE_BUTTON_ERROR_MESSAGES["REQUESTOR"] = "Requestor field required.";
        })(SAVE_BUTTON_ERROR_MESSAGES || (SAVE_BUTTON_ERROR_MESSAGES = {}));
        if (cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) {
            if (((_a = cpaProductContext.data.currentProductMetadata) === null || _a === void 0 ? void 0 : _a.sourceSystem) !==
                CpaProductMetadata.sourceSystem.CUSTOM &&
                process.env.REACT_APP_ENABLE_CPA_EDITS_FOR_CSP_PRODUCTS === 'FALSE') {
                errorMessages.push(SAVE_BUTTON_ERROR_MESSAGES.LEGACY_EDITS);
            }
            else {
                if (!((_c = (_b = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _b === void 0 ? void 0 : _b.currentProduct) === null || _c === void 0 ? void 0 : _c.deviationDesc)) {
                    errorMessages.push(SAVE_BUTTON_ERROR_MESSAGES.DEVIATION_DESC);
                }
                if (((_e = (_d = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _d === void 0 ? void 0 : _d.currentProduct) === null || _e === void 0 ? void 0 : _e.deviationDesc) &&
                    ((_h = (_g = (_f = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _f === void 0 ? void 0 : _f.currentProduct) === null || _g === void 0 ? void 0 : _g.deviationDesc) === null || _h === void 0 ? void 0 : _h.length) > DEVIATION_MAX_LENGTH) {
                    errorMessages.push(SAVE_BUTTON_ERROR_MESSAGES.DEVIATION_DESC_MAX_LENGTH);
                }
                if (((_j = cpaProductContext.data.currentProduct) === null || _j === void 0 ? void 0 : _j.requestor) === undefined) {
                    errorMessages.push(SAVE_BUTTON_ERROR_MESSAGES.REQUESTOR);
                }
            }
        }
        return errorMessages;
    }, [cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data]);
    return (_jsxs(Box, __assign({ className: styles.container }, { children: [_jsx(CpaProductHeaderBanner, { showBanner: showBanner, message: bannerMessage, messageType: bannerType, iconType: bannerIcon, isRefreshEnabled: isRefreshEnabled, isExtendedTimeEnabled: isExtendTimeEnabled, setIsExtendedTimeEnabled: setIsExtendTimeEnabled, setExtendTimeModelOpen: setExtendTimeModelOpen, setIsLockExtended: setIsLockExtended }), _jsxs(Box, __assign({ className: styles.titleContainer }, { children: [_jsx(Typography, __assign({ className: styles.pageTitle }, { children: "Special Products Customization" })), _jsx(Tooltip, __assign({ title: saveButtonErrors.length === 0 ? ('') : (_jsx("div", __assign({ style: { whiteSpace: 'pre-line' } }, { children: saveButtonErrors.map(function (e) { return e; }).join('\n\n') }))), slotProps: {
                            tooltip: {
                                sx: {
                                    fontSize: '14px',
                                },
                            },
                        }, arrow: true }, { children: _jsxs(Box, __assign({ className: styles.saveContainer }, { children: [_jsx(StyledButton, { labelText: "Save Product", height: "48px", width: "228px", buttonAction: handleSave, disabled: !isLocked || (cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.isEditDisabled) || saveButtonErrors.length > 0 }), _jsx(CpaUnsavedEditCheckLabel, {})] })) }))] })), _jsxs(Box, __assign({ className: styles.headerContainer }, { children: [(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.productType) === CpaProductType.SPECIAL_ORDER && (_jsx(CpaProductHeaderAdditionalInfoSpecials, {})), (cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.productType) === CpaProductType.WORK_ORDER && (_jsx(CpaProductHeaderAdditionalInfoWorkOrder, {})), _jsxs(Box, __assign({ className: styles.headerRightHalfContainer }, { children: [((_c = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct) === null || _c === void 0 ? void 0 : _c.standardProductReference) &&
                                cpaProductContext.data.cpn &&
                                (cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.productType) === CpaProductType.SPECIAL_ORDER && (_jsx(CpaProductHeaderPricing, { saveInProgress: saveLoading })), _jsxs(Box, __assign({ className: styles.messageContainer }, { children: [((_d = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct) === null || _d === void 0 ? void 0 : _d.createdBy) && (_jsxs("div", __assign({ className: styles.createdBy }, { children: ["Created By: ", (_e = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.currentProduct) === null || _e === void 0 ? void 0 : _e.createdBy] }))), anyRestrictions && _jsx("div", __assign({ className: styles.warningMessage }, { children: "Restriction Hold(s)" }))] }))] }))] })), extendTimeModelOpen && (_jsx(Box, __assign({ position: "absolute" }, { children: _jsx(ActionModal, __assign({ title: "5 Minutes Remaining...", buttonProps: [
                        {
                            labelText: 'Extend Lock',
                            backgroundColorVariation: 'primary',
                            width: '120px',
                            buttonAction: function () {
                                var lockString = sessionStorage.getItem("".concat(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn, "_lock"));
                                if (lockString) {
                                    var lock = JSON.parse(lockString);
                                    updateLockApi(cpaProductContext.data.cpn, lock.username, lock.sessionId, cpaProductContext.data.currentProduct.startDate);
                                    setExtendTimeModelOpen(false);
                                    setIsExtendTimeEnabled(false);
                                    setIsLockExtended(true);
                                }
                            },
                        },
                        {
                            labelText: 'Dismiss',
                            backgroundColorVariation: 'secondary',
                            width: '120px',
                            buttonAction: function () {
                                setExtendTimeModelOpen(false);
                                setIsExtendTimeEnabled(true);
                            },
                        },
                    ], isOpen: extendTimeModelOpen, setIsOpen: setExtendTimeModelOpen }, { children: _jsxs("div", __assign({ style: { paddingBottom: '50px' } }, { children: ["You have 5 minutes left to save changes before the 30 minute window closes.", _jsx("br", {}), _jsx("br", {}), "Would you like to extend 5 more minutes?"] })) })) }))), ' ', saveLoading && _jsx(LoadingSpinner, { indicatorSize: 10 })] })));
}
